import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ViewEncapsulation,
} from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MenuItem } from 'primeng/api'
import { Subscription } from 'rxjs'

export class StepsTrackingItem {
  stepStarted: boolean
  stepCompleted: boolean
  step: number
}

@Component({
  selector: 'basin-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'p-element',
  },
})
export class StepperComponent implements OnInit {
  @Input() stepsActiveIndex: number = 0
  @Input() stepItems: MenuItem[]
  @Input() readonly: boolean = false
  @Input() style: any
  @Input() styleClass: string
  @Input() stepsTracker: StepsTrackingItem[]
  @Output() stepsActiveIndexChange: EventEmitter<any> = new EventEmitter()

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {}

  subscription: Subscription

  ngOnInit() {
    this.subscription = this.router.events.subscribe(() =>
      this.cd.markForCheck()
    )
  }

  itemClick(event: Event, item: MenuItem, i: number) {
    if (this.readonly || item.disabled) {
      event.preventDefault()
      return
    }

    this.stepsActiveIndexChange.emit(i)

    if (!item.url && !item.routerLink) {
      event.preventDefault()
    }

    if (item.command) {
      item.command({
        originalEvent: event,
        item: item,
        index: i,
      })
    }
  }

  isClickableRouterLink(item: MenuItem) {
    return item.routerLink && !this.readonly && !item.disabled
  }

  isActive(item: MenuItem, index: number) {
    if (item.routerLink) {
      let routerLink = Array.isArray(item.routerLink)
        ? item.routerLink
        : [item.routerLink]

      return this.router.isActive(
        this.router
          .createUrlTree(routerLink, { relativeTo: this.route })
          .toString(),
        {
          paths: 'subset',
          queryParams: 'subset',
          fragment: 'ignored',
          matrixParams: 'ignored',
        }
      )
    }

    return index === this.stepsActiveIndex
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }
}
